import { render } from "./AdBanner.vue?vue&type=template&id=68c87191&scoped=true"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"

import "./AdBanner.vue?vue&type=style&index=0&id=68c87191&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c87191"]])

export default __exports__